import React from 'react';
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Card,
  Row,
  Col,
  Space,
  Divider,
  Checkbox,
} from 'antd';
import { FileSearchOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import MktuClassSelector from '../../common/MktuClassSelector';
import {
  TZ_FIELD_LABELS,
  REQUEST_FIELD_LABELS,
  WIPO_FIELD_LABELS,
  makeOptions,
} from './fieldLabels';

const { Item: FItem, List: FList } = Form;

/**
 * Форма конструктора поиска (запросник).
 * Рендерит поля формы; логика submit и состояние — в KonstruktorResults.
 */
const SearchForm = ({ activeTab, onScopeChange }) => {
  const OPTIONS =
    activeTab === 'tz'
      ? makeOptions(TZ_FIELD_LABELS)
      : activeTab === 'requests'
        ? makeOptions(REQUEST_FIELD_LABELS)
        : makeOptions(WIPO_FIELD_LABELS);

  return (
    <Card
      className="tz-konstruktor-search-card"
      title="Конструктор поиска"
      style={{ maxWidth: 900, width: '100%', marginBottom: 24 }}
      bodyStyle={{ paddingBottom: 24 }}
    >
      <Row gutter={16}>
        <Col span={24}>
          <FItem label="Где искать" name="scope" initialValue="tz">
            <Select
              style={{ width: '100%', maxWidth: 280, minWidth: 0 }}
              onChange={onScopeChange}
              options={[
                { value: 'tz', label: 'ТЗ' },
                { value: 'requests', label: 'Заявки' },
                { value: 'wipo', label: 'ВИПО' },
              ]}
            />
          </FItem>
        </Col>
        <Col span={24}>
          <FItem label="Текст запроса" name="text" rules={[{ required: true, message: 'Введите текст' }]}>
            <Input.TextArea rows={3} placeholder="Опишите, что ищете" />
          </FItem>
        </Col>

        <Col xs={24} md={12}>
          <FItem
            label="Поля для поиска"
            name="selectedFields"
            rules={[{ required: true, message: 'Выберите поля' }]}
          >
            <Select mode="multiple" options={OPTIONS} placeholder="Выберите поля" allowClear />
          </FItem>
        </Col>

        <Col xs={24} md={12}>
          <FItem label="Классы МКТУ" name="mktu">
            <MktuClassSelector placeholder="МКТУ" />
          </FItem>
        </Col>

        <Col xs={24} md={12}>
          <FItem label="Количество записей" name="quantity" initialValue={20}>
            <InputNumber min={1} max={200} style={{ width: '100%' }} />
          </FItem>
        </Col>

        <Col xs={24} md={12}>
          <FItem name="isPhonetic" valuePropName="checked" initialValue={false}>
            <Checkbox>Фонетический поиск</Checkbox>
          </FItem>
        </Col>

        <Col span={24}>
          <FItem>
            <Button type="primary" htmlType="submit" icon={<FileSearchOutlined />}>
              Найти
            </Button>
          </FItem>
        </Col>

        <Col span={24}>
          <Divider orientation="left">Доп. фильтры</Divider>
          <FList name="filters">
            {(fields, { add, remove }) => (
              <>
                <Space direction="vertical" style={{ width: '100%' }}>
                  {fields.map((f) => (
                    <Space key={f.key} align="baseline" wrap style={{ width: '100%' }}>
                      <Form.Item {...f} name={[f.name, 'key']} rules={[{ required: true }]}>
                        <Select options={OPTIONS} placeholder="Поле" style={{ width: '100%', maxWidth: 260, minWidth: 0 }} />
                      </Form.Item>
                      <Form.Item {...f} name={[f.name, 'value']} rules={[{ required: true }]} style={{ flex: 1 }}>
                        <Input placeholder="Значение" />
                      </Form.Item>
                      <Button type="text" icon={<DeleteOutlined />} onClick={() => remove(f.name)} danger />
                    </Space>
                  ))}
                  <Button type="dashed" block icon={<PlusOutlined />} onClick={() => add()}>
                    Добавить фильтр
                  </Button>
                </Space>
              </>
            )}
          </FList>
        </Col>
      </Row>
    </Card>
  );
};

export default SearchForm;
